import { useMembershipLevel } from "@hooks/membership";
import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fetchAiCreditsCheckConsumed, fetchCollectionDetail, fetchScriptGenerationResult } from "@apis/http/api";

export const useVideoReview = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id") || "";
  const collectionId = searchParams.get("collectionId") || "";

  const { isBasicUp } = useMembershipLevel();
  const refTimer = useRef<ReturnType<typeof setInterval>>();
  const [rewriteScriptList, setRewriteScriptList] = useState<any[]>([]);
  const [collectionDetail, setCollectionDetail] = useState<any>({});
  const [status, setStatus] = useState<Status>("loading");
  const [remainCredit, setRemainCredit] = useState(0);

  const showTranslate = async (translate: boolean = false, activeScript: number) => {
    if (translate) {
      setStatus("loading");
      const apiActiveScript = (activeScript % 2) + 1;
      const res: any = await fetchScriptGenerationResult({
        id: collectionDetail.id,
        translate,
        activeScript: apiActiveScript,
        requestId: collectionDetail.requestId,
      } as any);
      const newData = {
        ...rewriteScriptList[activeScript],
        requestId: rewriteScriptList[activeScript].requestId,
        video_scripts: res[`script${apiActiveScript}`],
        translate: true,
      };
      setRewriteScriptList((prev: any) =>
        prev.map((item: any, index: number) => {
          if (index === activeScript) {
            return newData;
          }
          return item;
        }),
      );
      setStatus("succeeded");
    } else {
      setRewriteScriptList((prev: any) =>
        prev.map((item: any, index: number) => {
          return { ...item, translate: index === activeScript ? false : item.translate };
        }),
      );
    }
  };

  const requestCollectionDetail = async () => {
    try {
      setCollectionDetail({ ...collectionDetail, status: "loading" });
      const data: any = await fetchCollectionDetail({ collectionId } as any);
      setCollectionDetail({ ...data, product_id: data.productId, product_title: data.productName, status: "loading" });
    } catch (error) {
      setCollectionDetail({ error, status: "failed" });
    }
  };

  // 获取视频脚本仿写结果
  const requestVideoScripteMulation = async ({ id, translate, requestId }: any) => {
    try {
      setStatus("loading");
      const res: any = await fetchScriptGenerationResult({
        id,
        translate,
        requestId,
        collectionId,
      } as any);
      setStatus("succeeded");
      const result: any = [];
      Object.keys(res).forEach((key) => {
        result.push({
          ...collectionDetail,
          videoId: id,
          requestId,
          translate,
          video_scripts: res[key],
        });
      });
      setRewriteScriptList(result);
    } catch (error) {
      setStatus("failed");
    }
  };

  const checkAiUse = async () => {
    const resUsed: any = await fetchAiCreditsCheckConsumed({ id, type: "videoScript" } as any);
    const remainCredit = (resUsed?.progressInfo?.remain || 0) / 100;
    setRemainCredit(remainCredit);
  };

  useEffect(() => {
    checkAiUse();
    requestCollectionDetail();
  }, []);

  return {
    collectionId,
    refTimer,
    isBasicUp,
    remainCredit,
    status,
    rewriteScriptList,
    collectionDetail,
    requestVideoScripteMulation,
    showTranslate,
    setCollectionDetail,
  };
};
